/**
 * @generated SignedSource<<84d234b248576705f133c5b1f3472fbd>>
 * @relayHash 5b3dfdb31add0b8501567a6a4ec4611d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5b3dfdb31add0b8501567a6a4ec4611d

import { ConcreteRequest } from 'relay-runtime';
export type De_signAttestationGuardianDocumentWithTelematikInfrastructureInput = {
  id: string;
};
export type useDeSignLegalGuardianWithTelematikInfrastructureMutation$variables = {
  input: De_signAttestationGuardianDocumentWithTelematikInfrastructureInput;
};
export type useDeSignLegalGuardianWithTelematikInfrastructureMutation$data = {
  readonly de_signAttestationGuardianDocumentWithTelematikInfrastructure: {
    readonly de_AttestationGuardian: {
      readonly createdAt: string;
      readonly createdBy: string;
      readonly fileId: string | null;
      readonly id: string;
      readonly signedAt: string | null;
      readonly signedBy: string | null;
      readonly updatedAt: string | null;
      readonly updatedBy: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly errorType?: string;
      readonly message?: string;
    }> | null;
  };
};
export type useDeSignLegalGuardianWithTelematikInfrastructureMutation = {
  response: useDeSignLegalGuardianWithTelematikInfrastructureMutation$data;
  variables: useDeSignLegalGuardianWithTelematikInfrastructureMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "De_signAttestationGuardianDocumentWithTelematikInfrastructurePayload",
    "kind": "LinkedField",
    "name": "de_signAttestationGuardianDocumentWithTelematikInfrastructure",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "de_AttestationGuardian",
        "kind": "LinkedField",
        "name": "de_AttestationGuardian",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "errorType",
                "storageKey": null
              }
            ],
            "type": "SignDocumentMutationFailed",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeSignLegalGuardianWithTelematikInfrastructureMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeSignLegalGuardianWithTelematikInfrastructureMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "5b3dfdb31add0b8501567a6a4ec4611d",
    "metadata": {},
    "name": "useDeSignLegalGuardianWithTelematikInfrastructureMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e4c8d3377612e081b65d544c52f249e7";

export default node;
